import Section from "../../modules/section/Section";
import CardList from "../../modules/cardList/CardList";
import cardlist1 from "../../../assets/images/cardlist1.png";
import cardlist1_mob from "../../../assets/images/cardlist1_mob.png";
import cardlist2 from "../../../assets/images/cardlist2.png";
import cardlist2_mob from "../../../assets/images/cardlist2_mob.png";
import cardlist3 from "../../../assets/images/cardlist3.png";
import cardlist4 from "../../../assets/images/cardlist4.png";
import {useTranslation} from "react-i18next";

const Projects = () => {
  const { t } = useTranslation();
  const projects = [
    {
      title: t("energyInfrastructureTitle"),
      superTitle: t("energyInfrastructure"),
      link: 'energy-and-infrastructure',
      src: cardlist1,
      srcMob: cardlist1_mob,
    },
    {
      title: t("miningTitle"),
      superTitle: t("mining"),
      link: 'mining',
      src: cardlist3,
      srcMob: cardlist3,
    },
    {
      title: t("realEstateTitle"),
      superTitle: t("realEstate"),
      link: 'real-estate',
      src: cardlist2,
      srcMob: cardlist2_mob,
    },
    {
      title: t("MATitle"),
      superTitle: t("MA"),
      link: 'm-and-a',
      src: cardlist4,
      srcMob: cardlist4,
    },
  ];

  return (
    <>
      <Section>
        <CardList cards={projects} />
      </Section>
    </>
  );
}

export default Projects;